<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">邀请图片</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>平台：</label>
          <el-select v-model="platform" placeholder="Select" style="width: 7em" @change='channelChange'>
            <el-option v-for="item in platformArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>渠道：</label>
          <el-select v-model="channel" placeholder="Select" style="width: 7em">
            <el-option v-for="item in channelArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 7em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
<!--        <div class="content-input-item">-->
<!--          <DatePickerRange title="创建时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>-->
<!--        </div>-->
<!--        <div class="content-input-item">-->
<!--          <DatePickerRange title="发表时间：" @date="getExpireTime($event)" @check="getExpireCheck($event)" :isChecked="isExpireChecked"/>-->
<!--        </div>-->
<!--        <div class="content-input-item">-->
<!--          <SearchComponents :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />-->
<!--        </div>-->
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" :loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editTagDialog(-1)">添加</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            border
        >
<!--          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>-->
          <el-table-column property="updateTime" label="更新时间" v-if="checkColList.indexOf('更新时间') > -1"/>
          <el-table-column property="" label="邀请图片" v-if="checkColList.indexOf('邀请图片') > -1" class-name="cursor">
            <template #default="scope">
              <el-image style="width: 80px; height: 80px" :src="scope.row.img"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="showTime" label="平台"  v-if="checkColList.indexOf('平台') > -1">
            <template #default="scope">
              <span>{{scope.row.platform==1?'Android':scope.row.platform==2?'iOS':scope.row.platform==4?'鸿蒙':''}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="渠道" v-if="checkColList.indexOf('渠道') > -1">
            <template #default="scope">
              <span>{{scope.row.appChannel==''?'不限':scope.row.appChannel}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              <span>{{scope.row.state==1?'待展示':scope.row.state==2?'展示中':'已下架'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
<!--              <el-button size="small" @click="editTagDialog(scope.$index,scope.row)" type="primary">编辑</el-button>-->
              <el-button type="success" size="small" @click="updateState(2, scope.row, scope.$index)" v-if="scope.row.state == 0 || scope.row.state == 1 || scope.row.state == 3" v-loading="scope.row.updateLoading">上架</el-button>
              <el-button type="danger" size="small" @click="updateState(3, scope.row, scope.$index)" v-if="scope.row.state == 1 || scope.row.state == 2" v-loading="scope.row.updateLoading">下架</el-button>
<!--              <el-button type="success" plain size="small" @click="preview(scope.row)">预览</el-button>-->
            </template>
          </el-table-column>
          <el-table-column property="remark" label="备注" v-if="checkColList.indexOf('备注') > -1" class-name="cursor"/>
<!--          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">-->
<!--            <template #default="scope">-->
<!--              <UserLog :user-log-list="scope.row.userLogList" />-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import BtnGroup from '../../components/BtnGroup'
import ImgViewer from '../../assets/js/imageViewer'
import {
  getInviteQrCodePageList, updateQrCodeImgState, qrCodeChannelList
} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import UserLogDialog from "@/components/UserLog/UserLogDialog";
import UserLog from "@/components/UserLog/UserLog";
import InviteImgDialog from "@/views/invite/components/InviteImgDialog";
import InviteImgUpload from "@/views/invite/components/InviteImgUpload";
import ImgRemarkDialog from "@/views/invite/components/ImgRemarkDialog";
// import LetterPreview from "@/views/love/components/LetterPreview";

export default {
  name: "LoveLetter",
  components: { DatePickerRange, SearchComponents, BtnGroup, UserLog },
  data() {
    return {

      //平台
      platformArray: [
        {label:'不限', value: 0},
        {label:'Android', value: 1},
        {label:'IOS', value: 2},
        {label:'鸿蒙', value: 4},
      ],
      platform: 0,

      //渠道
      channelArray: [
        { label: '不限', value: ''}
      ],
      androidChannelArray: [],
      iosChannelArray: [],
      channel: '',

      stateArray: [
        {label: '不限', value: 0},
        {label: '待展示', value: 1},
        {label: '展示中', value: 2},
        {label: '已下架', value: 3}
      ],
      state: 0,


      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //发表时间
      startExpire: '',
      endExpire: '',
      isExpireChecked: true,

      //搜索
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['更新时间', '邀请图片', '平台', '渠道', '状态', '操作', '备注'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      listLoading: false,
      searchLoading: false,
      bitchPassLoading: false,
      bitchRejectLoading: false,
      bitchHideLoading: false,
      bitchForbidLoading: false,


      idArray: [],

    }
  },
  methods: {

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },

    getExpireTime(val) {
      this.startExpire = val[0];
      this.endExpire = val[1];
      // console.log(val)
    },

    getExpireCheck(val) {
      this.isExpireChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      // this.isChecked = true;
      // this.isExpireChecked = true;
      this.state = 0;
      this.platform = 0;
      this.channel = '';
      // this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.msgId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.msgId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    channelChange(val) {
      this.channelArray = [
        { label: '不限', value: ''}
      ]
      this.channel = ''
      if(val == 0) {
        this.channelArray = [...this.channelArray, ...this.androidChannelArray, ...this.iosChannelArray]
      }else if(val == 1) {
        this.channelArray = [...this.channelArray, ...this.androidChannelArray]
      }else if(val == 2) {
        this.channelArray = [...this.channelArray, ...this.iosChannelArray]
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      param['platform'] = this.platform;
      param['appChannel'] = this.channel;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getInviteQrCodePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      if(column.label == '邀请图片') {
        Dialog.open({
          title: '邀请图片',
          component: InviteImgUpload,
          data: {
            id: row.id,
            src: row.img,
            width: '400px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '备注') {
        Dialog.open({
          title: '添加备注',
          component: ImgRemarkDialog,
          data: {
            id: row.id,
            remark: row.remark,
            width: '500px'
          },
          confirm: (result) => {
            row.remark = result.remark
          }
        })
      }

    },


    updateState(state, row, idx) {
      this.$confirm('确认'+ (state == 2?'【上架】':'【下架】') +'选中的图片').then(()=>{
        row.updateLoading = true
        let _this = this;
        let param = {};
        param['id'] = row.id
        param['state'] = state
        postFormData(updateQrCodeImgState, param).then((data) => {
          let {code, msg} = data;
          if(code == 200) {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            row.state = state
          }else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          row.updateLoading = false;
        })
            .catch(()=>{
              row.updateLoading = false;
            })
      })
    },


    editTagDialog(idx, row) {
      let _title = '';
      let imgForm = {}
      if (idx > -1) {
        _title = '编辑二维码'
        imgForm = Object.assign({}, row);
      }else {
        _title = '添加二维码'
      }
      Dialog.open({
        title: _title,
        component: InviteImgDialog,
        data: {
          imgForm: imgForm,
          ids: idx,
          width: '500px'
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList
      })
    },

    //获取渠道
    getChannel() {
      let _this = this;
      let param = {};
      // param['platform'] = this.platform;
      getFormData(qrCodeChannelList, param).then(function(data){
        for(let item of data.data) {
          if(item.channel != '') {
            let obj = { label: item.channel, value: item.channel};
            if(item.platformType == 1) {
              _this.androidChannelArray.push(obj)
            }else if(item.platformType == 2) {
              _this.iosChannelArray.push(obj)
            }
          }
        }
        _this.channelArray = [..._this.channelArray, ..._this.androidChannelArray, ..._this.iosChannelArray];
      })
    },

  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getChannel();
    this.getPage();
  }
}
</script>

<style scoped>

</style>
